module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step2_Image22.85c2078a.webp";